import { render, staticRenderFns } from "./course-selector.vue?vue&type=template&id=143f76b2&"
import script from "./course-selector.vue?vue&type=script&lang=js&"
export * from "./course-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports